<template>
  <div>
    <div class="form-steps">
      <div class="helper_action__container">
        <el-steps class="helper_action__bar" direction="vertical">
          <el-step
              v-for="(item, index) in stepsData"
              :align-center="false"
              :title="item.title"
              :description="item.description"
              :status="checkFiledStatus(item.stepStatus)"
              :key="index">
          </el-step>
        </el-steps>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "FormHeader",
  props: {
    selectedStep: {
      required: true
    }
  },
  data() {
    return {
    }
  },
  computed: {
    stepsData() {
      return [
        {
          title: 'Шаг 1. Начальные данные',
          description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
          buttonTitle: 'Добавить салон',
          actionUrl: '',
          stepStatus:  this.selectedStep === 1
        },
        {
          title: 'Шаг 2. Данные профиля',
          description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
          buttonTitle: 'Добавить услуги',
          actionUrl: '',
          stepStatus:  this.selectedStep === 2
        },
        {
          title: 'Шаг 3. Подтверждение регистрации',
          description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
          buttonTitle: 'Добавить сотрудников',
          actionUrl: '',
          stepStatus: this.selectedStep === 3
        },
        {
          title: '',
          description: '',
          buttonTitle: '',
          actionUrl: []
        }


      ]
    }
  },
  methods: {
    checkFiledStatus(section) {
      return section ? 'process' : 'wait'
    }
  }
};
</script>

<style lang="sass">
  .selected
    color: red
    opacity: 1

  .disabled
    opacity: 0.5

  .form-header

    &-text
      font-size: 34px
      font-weight: bold
      color: #363636

    &-steps
      display: flex
      margin-top: 16px
      user-select: none

      &_step
        margin-right: 16px
        font-size: 16px
        font-weight: 500
        color: #000000

        &_arrow
          margin-right: 4px
  .helper_action
    &__container
      display: flex
      flex-direction: row
      min-height: calc(100vh - 280px)
      align-items: stretch
      justify-content: center
      flex: 1
    &__bar
      .el-step.is-vertical
        flex-direction: row-reverse
        text-align: right
      .el-step
        &__title
          padding-right: 2%
          text-align: right
        &__description
          text-align: right
          padding-right: 2%
          padding-bottom: 6%
          visibility: hidden
        &.is-vertical
          .el-step__title
            padding-bottom: 6%
        &:last-child
          .el-step__head
            visibility: hidden
  .el-step__icon
    &.is-text
      .el-step__icon-inner
        visibility: hidden
      .is-process &
        background-color: #363636
        border-color: #363636
      .is-wait &
        background-color: #9e9e9e
        border-color: #9e9e9e
</style>
